import { HttpClient } from './http-client';
import { Observable } from 'rxjs';
import LivestockSomaticCells, { SomaticCellsInfo } from '../interfaces/livestock-somatic-cells';

export class LivestockSomaticCellsService extends HttpClient {

  summaryType(farmId: string, id: string): Observable<LivestockSomaticCells> {
    return this.get<LivestockSomaticCells>(
      `/api/farms/${farmId}/livestock/summary/dairy/somatic-cells/type/${id}`
    );
  }

  summaryInfo(farmId: string, date: string, summary: string): Observable<SomaticCellsInfo> {
    return this.get<SomaticCellsInfo>(
      `/api/farms/${farmId}/livestock/summary/dairy/somatic-cells/getSomaticCellsInfo/${date}/${summary}`
    );
  }  
}
